export const QUOTA_HISTORY_TABLE_COLUMNS = [
	{ key: 'createdAt', label: 'วันที่' },
	{ key: 'winningQuotaAmount', label: 'Winning Quota' },
	{ key: 'creditQuotaAmount', label: 'Credit Quota' },
	{ key: 'amount', label: 'ยอดรวม' },
	{ key: 'note', label: 'หมายเหตุ' },
] as const
